<template>
  <div class="grid grid-cols-2 col-gap-12 px-8">
    <div>
      <form @submit.prevent="">
        <VFormInput
          placeholder="Enter pre-training title"
          label="Title*"
          :initialValue="initialValues.title"
          :error="errors.title"
          @update="value => $emit('set', 'title', value)"
        />
        <VFormTextarea
          placeholder="Enter summary"
          label="Summary*"
          :initialValue="initialValues.summary"
          :error="errors.summary"
          @update="value => $emit('set', 'summary', value)"
        />
        <VFormInput
          placeholder="Enter pre-training order"
          label="Order*"
          :onlyDigits="true"
          :initialValue="initialValues.order"
          :error="errors.order"
          @update="value => $emit('set', 'order', value)"
        />
        <VFormTextarea
          placeholder="Enter embedded code"
          label="Embedded Code*"
          :initialValue="initialValues.embed_code"
          :error="errors.embed_code"
          @update="value => $emit('set', 'embed_code', value)"
        />
      </form>
    </div>
    <div>
      <VFormUploadImage
        :initialSrc="initialValues.thumbnail_path"
        @upload="file => $emit('set', 'thumbnail', file)"
      />
      <div v-if="showIntro">
        <VFormCheckbox
          label="Is Intro Video*"
          :initialValue="!!parseInt(initialValues.is_intro_video)"
          :error="errors.is_intro_video"
          @update="value => $emit('set', 'is_intro_video', value)"
          :isToggle="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VFormInput from '@/components/base/VFormInput';
import VFormTextarea from '@/components/base/VFormTextarea';
import VFormCheckbox from '@/components/base/VFormCheckbox';
import VFormUploadImage from '@/components/base/VFormUploadImage';

export default {
  name: 'VideoForm',
  components: {
    VFormInput,
    VFormTextarea,
    VFormCheckbox,
    VFormUploadImage,
  },
  props: {
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    showIntro: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>
